import styled from 'styled-components'

export const Input = styled.input`
  outline: none;
  width: 100%;
  padding: 5px 10px;
  font-size: 14px;
  border: 1px solid rgb(232, 232, 232);
  border-radius: 2px;

  &:focus {
    border-color: ${p => p.theme.colors.primary};
  }
`
